import { difference, differenceWith, isEmpty, isEqual, isObject, transform } from 'lodash';
import { convertToBase64 } from 'utils/getIcons';

const isPropertyUpdated = (previous: any, newValue: any, keys: string[]) => {
  if (previous && newValue) {
    return keys.some(key => previous[key] !== newValue[key]);
  } else {
    return true;
  }
};

export const getAssetFormData = (file: File) => {
  const mediaUploadForm = new FormData();
  if (!isEmpty(file)) {
    mediaUploadForm.append('files', file);
  }
  return mediaUploadForm;
};

export const mapSocialFeedPublishData = async (currentData: any, currentConfig: any, previousData: any) => {
  const settingsData = {
    webGlobalSettings: null,
    mobileGlobalSettings: null,
    webFilters: null,
    mobileFilter: null,
    webBannerSettings: null,
    wedFeedPlayerSettings: null,
    webFeedShareSettings: null,
    webFeedCommentSettings: null,
    webNavigationHomeSettings: null,
    webNavigationFeedSettings: null,
    webNavigationUserProfileSettings: null,
    webNavigationCourseSettings: null,
    mobileBannerSettings: null,
    mobileFeedPlayerSettings: null,
    mobileFeedShareSettings: null,
    mobileFeedCommentSettings: null,
    mobileNavigationHomeSettings: null,
    mobileNavigationFeedSettings: null,
    mobileNavigationUserProfileSettings: null,
    mobileNavigationCourseSettings: null
  };

  const isGlobalSettingsUpdated = isPropertyUpdated(previousData.global, currentData.WEB.globalSettings, [
    'logo',
    'typography',
    'primaryColor',
    'sideBarColor',
    'topBarColor',
    'sideBarWidth'
  ]);
  if (isGlobalSettingsUpdated) {
    const webGlobalSettings: any = { ...currentData.WEB.globalSettings };
    settingsData.webGlobalSettings = webGlobalSettings;
  }

  const isGlobalMobileSettingsUpdated = isPropertyUpdated(
    previousData.mobileGlobal,
    currentData.MOBILE.globalSettings,
    ['logo', 'typography', 'primaryColor', 'bottomBarColor', 'topBarColor']
  );

  if (isGlobalMobileSettingsUpdated) {
    const mobileGlobalSettings: any = { ...currentData.MOBILE.globalSettings };
    settingsData.mobileGlobalSettings = mobileGlobalSettings;
  }

  // FILTER SETTING WEB
  if (!isEqual(previousData.filter, currentData.WEB.filterSettings)) {
    settingsData.webFilters = currentData.WEB.filterSettings;
  }

  function deepDiff(obj1: any, obj2: any) {
    return transform(
      obj1,
      (result: any, value, key) => {
        if (!isEqual(value, obj2[key])) {
          result[key] = isObject(value) && isObject(obj2[key]) ? deepDiff(value, obj2[key]) : value;
        }
      },
      {}
    );
  }
  console.log('DIFF Previous: ', previousData.filter);
  console.log('DIFF New: ', currentData.WEB.filterSettings);
  console.log('DIFF 1: ', differenceWith(previousData.filter, currentData.WEB.filterSettings, isEqual));
  console.log('DIFF 2: ', deepDiff(previousData.filter, currentData.WEB.filterSettings));
  if (!isEqual(previousData.mobileFilter, currentData.MOBILE.filterSettings)) {
    settingsData.mobileFilter = currentData.MOBILE.filterSettings;
  }

  // BANNER SETTING WEB
  const isWebBannerSettingsUpdated = isPropertyUpdated(currentConfig.web.banner, currentData.WEB.topBannerSettings, [
    'color',
    'title',
    'description',
    'showBanner',
    'usePrimaryColor',
    'primaryConversion',
    'secondaryConversion'
  ]);

  if (isWebBannerSettingsUpdated) {
    settingsData.webBannerSettings = currentData.WEB.topBannerSettings;
  }

  // FEED PLAYER SETTING WEB
  const isWebFeedPlayerSettingsUpdated = isPropertyUpdated(
    currentConfig.web.feed.player,
    currentData.WEB.playbackSettings,
    ['showTitle', 'showDescription']
  );

  if (isWebFeedPlayerSettingsUpdated) {
    settingsData.wedFeedPlayerSettings = currentData.WEB.playbackSettings;
  }

  // FEED SHARE SETTING WEB
  const isWebFeedShareSettingsUpdated = isPropertyUpdated(
    currentConfig.web.feed.share,
    currentData.WEB.shareabilitySettings,
    ['customMessage']
  );

  if (
    isWebFeedShareSettingsUpdated ||
    !isEqual(currentConfig.web.feed.share.shareOptions, currentData.WEB.shareabilitySettings.shareOptions)
  ) {
    settingsData.webFeedShareSettings = currentData.WEB.shareabilitySettings;
  }

  // FEED COMMENT SETTING WEB
  const isWebFeedCommentSettingsUpdated = isPropertyUpdated(
    currentConfig.web.feed.comment,
    currentData.WEB.commentSettings,
    ['moderationType', 'moderationPromptDo', 'moderationPromptDont']
  );

  if (isWebFeedCommentSettingsUpdated) {
    settingsData.webFeedCommentSettings = currentData.WEB.commentSettings;
  }

  // NAVIGATION HOME SETTING WEB
  const isWebNavigationHomeSettingsUpdated = isPropertyUpdated(
    currentConfig.web.navigation.home,
    currentData.WEB.navigationSettings.home,
    ['title', 'icon']
  );

  if (isWebNavigationHomeSettingsUpdated) {
    settingsData.webNavigationHomeSettings = currentData.WEB.navigationSettings.home;
  }

  // NAVIGATION FEED SETTING WEB
  const isWebNavigationFeedSettingsUpdated = isPropertyUpdated(
    currentConfig.web.navigation.feed,
    currentData.WEB.navigationSettings.feed,
    ['title', 'icon']
  );

  if (isWebNavigationFeedSettingsUpdated) {
    settingsData.webNavigationFeedSettings = currentData.WEB.navigationSettings.feed;
  }

  // NAVIGATION USER PROFILE SETTING WEB
  const isWebNavigationUserProfileSettingsUpdated = isPropertyUpdated(
    currentConfig.web.navigation.userProfile,
    currentData.WEB.navigationSettings.userprofile,
    ['title', 'icon']
  );

  if (isWebNavigationUserProfileSettingsUpdated) {
    settingsData.webNavigationUserProfileSettings = currentData.WEB.navigationSettings.userprofile;
  }

  // NAVIGATION COURSE SETTING WEB
  const isWebNavigationCourseSettingsUpdated = isPropertyUpdated(
    currentConfig.web.navigation.course,
    currentData.WEB.navigationSettings.course,
    ['title']
  );

  if (isWebNavigationCourseSettingsUpdated) {
    settingsData.webNavigationCourseSettings = currentData.WEB.navigationSettings.course;
  }

  // BANNER SETTING MOBILE
  const isMobileBannerSettingsUpdated = isPropertyUpdated(
    currentConfig.mobile.banner,
    currentData.MOBILE.topBannerSettings,
    ['color', 'title', 'description', 'showBanner', 'usePrimaryColor', 'primaryConversion', 'secondaryConversion']
  );

  if (isMobileBannerSettingsUpdated) {
    settingsData.mobileBannerSettings = currentData.MOBILE.topBannerSettings;
  }

  // FEED PLAYER SETTING MOBILE
  const isMobileFeedPlayerSettingsUpdated = isPropertyUpdated(
    currentConfig.mobile.feed.player,
    currentData.MOBILE.playbackSettings,
    ['showTitle', 'showDescription']
  );

  if (isMobileFeedPlayerSettingsUpdated) {
    settingsData.mobileFeedPlayerSettings = currentData.MOBILE.playbackSettings;
  }

  // FEED SHARE SETTING MOBILE
  const isMobileFeedShareSettingsUpdated = isPropertyUpdated(
    currentConfig.mobile.feed.share,
    currentData.MOBILE.shareabilitySettings,
    ['customMessage']
  );

  if (
    isMobileFeedShareSettingsUpdated ||
    !isEqual(currentConfig.mobile.feed.share.shareOptions, currentData.MOBILE.shareabilitySettings.shareOptions)
  ) {
    settingsData.mobileFeedShareSettings = currentData.MOBILE.shareabilitySettings;
  }

  // FEED COMMENT SETTING MOBILE
  const isMobileFeedCommentSettingsUpdated = isPropertyUpdated(
    currentConfig.mobile.feed.comment,
    currentData.MOBILE.commentSettings,
    ['moderationType', 'moderationPromptDo', 'moderationPromptDont']
  );

  if (isMobileFeedCommentSettingsUpdated) {
    settingsData.mobileFeedCommentSettings = currentData.MOBILE.commentSettings;
  }

  // NAVIGATION HOME SETTING MOBILE
  const isMobileNavigationHomeSettingsUpdated = isPropertyUpdated(
    currentConfig.mobile.navigation.home,
    currentData.MOBILE.navigationSettings.home,
    ['title', 'icon']
  );

  if (isMobileNavigationHomeSettingsUpdated) {
    settingsData.mobileNavigationHomeSettings = currentData.MOBILE.navigationSettings.home;
  }

  // NAVIGATION FEED SETTING MOBILE
  const isMobileNavigationFeedSettingsUpdated = isPropertyUpdated(
    currentConfig.mobile.navigation.feed,
    currentData.MOBILE.navigationSettings.feed,
    ['title', 'icon']
  );

  if (isMobileNavigationFeedSettingsUpdated) {
    settingsData.mobileNavigationFeedSettings = currentData.MOBILE.navigationSettings.feed;
  }

  // NAVIGATION USER PROFILE SETTING MOBILE
  const isMobileNavigationUserProfileSettingsUpdated = isPropertyUpdated(
    currentConfig.mobile.navigation.userProfile,
    currentData.MOBILE.navigationSettings.userprofile,
    ['title', 'icon']
  );

  if (isMobileNavigationUserProfileSettingsUpdated) {
    settingsData.mobileNavigationUserProfileSettings = currentData.MOBILE.navigationSettings.userprofile;
  }

  // NAVIGATION COURSE SETTING MOBILE
  const isMobileNavigationCourseSettingsUpdated = isPropertyUpdated(
    currentConfig.mobile.navigation.course,
    currentData.MOBILE.navigationSettings.course,
    ['title']
  );

  if (isMobileNavigationCourseSettingsUpdated) {
    settingsData.mobileNavigationCourseSettings = currentData.MOBILE.navigationSettings.course;
  }

  return settingsData;
};
